import styled from 'styled-components';
import { title, screenReaderOnly as srOnlyMixin } from '../Mixins/Mixins';
import { strictSpace } from '../../utils';
var Legend = styled.legend.withConfig({
  displayName: "Legend",
  componentId: "sc-1n63yuu-0"
})(["", " ", " ", ""], title, strictSpace, function (_ref) {
  var screenReaderOnly = _ref.screenReaderOnly;
  return screenReaderOnly ? srOnlyMixin : '';
});
Legend.defaultProps = {
  mb: 'none'
};
export default Legend;